import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  creativeCard: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px solid #ddd',
    minWidth: 270,
    maxWidth: 270,
    position: 'relative',
    boxShadow: '10px 10px 30px rgba(0,0,0,0.2)',
  },
  creativeCardNoShadow: { boxShadow: 'none' },
  creativeCardWrapper: {
    background: '#fafafa',
    padding: 5,
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderBottom: '1px solid #ddd',
  },
  noBG: { minHeight: 0, maxHeight: 0, height: 0 },
  noProfile: { display: 'none' },
  creativeCardBackground: {
    minWidth: 80,
    maxWidth: 80,
    minHeight: 80,
    maxHeight: 80,
    borderRadius: '50%',
    border: '5px solid #fff',
    marginTop: -50,
  },
  profileNoBG: { marginTop: 10 },
  creativeCardDetails: {
    padding: 20,
    paddingTop: 0,
    paddingBottom: 0,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  actionsWrapper: {
    display: 'flex',
    padding: 5,
    width: '100%',
    paddingTop: 10,
    paddingBottom: 10,
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fafafc',
  },
  creativeCardInvited: {
    boxShadow: `0 0 30px ${theme.palette.primary.light}`,
    border: `1px solid ${theme.palette.primary.light}`,
  },
  favIcon: {
    color: theme.palette.primary.main,
    fontSize: 16,
    padding: 10,
    paddingTop: 3,
    paddingBottom: 3,
    margin: 0,
    cursor: 'pointer',
  },
  favIconStar: {
    color: '#444',
    fontSize: 12,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 3,
    paddingBottom: 3,
    margin: 0,
    cursor: 'pointer',
  },
  smallActionWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    background: 'rgba(255,255,255,1)',
    width: 60,
    paddingTop: 5,
    paddingBottom: 5,
    boxShadow: 'inset 3px 3px 5px rgba(0,0,0,0.2)',
  },

  top: { top: 0, borderRadius: '0 0 0 5px' },
  actionText: {
    fontSize: 12,
    fontWeight: 600,
    marginTop: -2,
    color: '#222',
    width: 20,
  },
}));
